import { Typography } from "@sgi/gravity/Typography";
import type { ReactNode } from "react";

export default function ButtonLink({ testid, handleClick, linkCaption, float } : Readonly<{
  testid?: string
  handleClick: () => void
  linkCaption: ReactNode
  float?: "left" | "right"
}>) {
  return (
    <button
      data-testid={testid}
      type="button"
      onClick={handleClick}
      style={float && {float: float}}
    >
      <Typography variant="bodyBold" type="link" textDecoration="underline">
        {linkCaption}
      </Typography>
    </button>
  );
}
